const KronologicEnterprise = "enterprise";

export const isEnterpriseMode =
  window?.config?.["APPLICATION_MODE"] === KronologicEnterprise;
